const data = {
    categories: [
        'All ',
        'Featured', 
        'Technical Projects',
    //   - Design
    //   - Mobile
    //   - Web stuff
    //   - Java
    //   - Python
    //   - Assembly
        'Entrepreneurship/Hackathons',
        'Newsletters/Article Writing'
    ],
    techCategories: [
        'All',
        'ReactJS',
        'HTML',
        'CSS',
        'Flutter',
        'Dart',
        'Django',
        'Docker',
        'Postman',
        'Python',
        'Assembly',
        'Github',
        'Firebase',
        'Java',
        'AWS',
        'Javascript',
        'Android',
        'Mobile App',
        'Web App',
        'Website',
        'Game'
    ]
    
} 
export default data;